import React, {useEffect, useRef, useState} from "react";
import { NavLink, useLocation } from "react-router-dom";
import useMobile from "../../../../../hooks/useMobile";
import { useOnClickOutside } from "components/hooks";
import {
	SettingsCart,
	SettingsCreate, SettingsCrypto, SettingsCurrencies, SettingsDesign, SettingsFraud, SettingsGatewayFees,
	SettingsIdentity, SettingsManagers,
	SettingsNotification, SettingsPayments,
	SettingsSecurity, SettingsShop, SettingsSubs, SettingsTax,
	SettingsUser, SettingsShopify
} from '../../dashboard/sidebar/icons/icons/icons';
import { useSelector } from "react-redux";
import { ChevronDown } from "../../../../../components/icons";
import { BackIcon } from "../../../../builder/screens/visual/EditorMenu/ThemeSettings";
import { CustomersAffiliate } from "../../dashboard/sidebar/icons/icons";

import "./index.scss";

const ICONS = {
	'/settings/general': <SettingsUser />,
	'/settings/personal': <SettingsIdentity />,
	'/settings/security': <SettingsSecurity />,
	'/settings/notifications': <SettingsNotification />,
	'/settings/create/shop': <SettingsCreate />,
	'/settings/shop/general': <SettingsShop />,	'/settings/shop/payments': <SettingsPayments />,
	// Temporarily hidden - old crypto system is deprecated and being replaced with Cryptomus
	// '/settings/shop/crypto': <SettingsCrypto />,
	'/settings/shop/tax': <SettingsTax />,
	'/settings/shop/cart': <SettingsCart />,
	'/settings/shop/subscription': <SettingsSubs />,
	'/settings/shop/design': <SettingsDesign />,
	'/settings/shop/fraud': <SettingsFraud />,
	'/settings/shop/managers': <SettingsManagers />,
	'/settings/shop/affiliate': <CustomersAffiliate />,
	'/settings/shop/gateway-fees': <SettingsGatewayFees />,
	'/settings/shop/currencies': <SettingsCurrencies />,
	'/settings/shop/shopify': <SettingsShopify isActive={true} />
}

const TEXT = {
	'/settings/general': 'General',
	'/settings/personal': 'Identity',
	'/settings/security': 'Security',
	'/settings/notifications': 'Notification',
	'/settings/create/shop': 'Create Shop',
	'/settings/shop/general': 'General',	'/settings/shop/payments': 'Payments',
	// Temporarily hidden - old crypto system is deprecated and being replaced with Cryptomus
	// '/settings/shop/crypto': 'Cryptocurrencies',
	'/settings/shop/tax': 'Tax',
	'/settings/shop/cart': 'Shopping Cart',
	'/settings/shop/subscription': 'Subscriptions',
	'/settings/shop/design': 'Design',
	'/settings/shop/fraud': 'Fraud',
	'/settings/shop/managers': 'Managers',
	'/settings/shop/affiliate': 'Affiliate',
	'/settings/shop/gateway-fees': 'Gateway Adjustments',
	'/settings/shop/shopify': 'Shopify'
}

const MobileNav = () => {

	const { pathname } = useLocation();
	const isMobile = useMobile();
	const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);
	const isShopify = pathname.includes("/settings/shop/shopify");

	let dropdownRef = useRef();

	let [buttonDropdown, setButtonDropdown] = useState(false);

	let closeDropdownMenu = () => setButtonDropdown(false);
	let toggleDropdownMenu = () => setButtonDropdown(!buttonDropdown);

	useOnClickOutside(dropdownRef, closeDropdownMenu);

	useEffect(() => {
		closeDropdownMenu();
	}, [pathname])

	if(!isMobile) {
		return null
	}

	return <div className={`settings-mobile-nav ${buttonDropdown ? 'open' : ''}`} ref={dropdownRef}>

		<div className="settings-mobile-nav-current" onClick={toggleDropdownMenu}>
			{buttonDropdown ? <div className="settings-mobile-nav-back"><BackIcon /></div> : null}
			<div>{ICONS[pathname]} {TEXT[pathname]}</div>
			{buttonDropdown ? null : <div className="settings-mobile-nav-back"><ChevronDown /></div>}
		</div>

		<div className={`settings-mobile-nav-body ${buttonDropdown ? 'd-flex' : 'd-none'}`} style={{ height: `calc(100svh - ${bannerHeight}px - 3.5rem)`}}>
			<div className="settings-mobile-nav-list">
				<div className="settings-mobile-nav-list-title">User</div>
				<div className="settings-mobile-nav-list-body">
					<NavLink activeClassName="active" to="/settings/general" id="settings-user-general"><SettingsUser /><span>General</span> </NavLink>
					<NavLink activeClassName="active" to="/settings/personal" id="settings-user-personal"><SettingsIdentity /><span>Identity</span></NavLink>
					<NavLink activeClassName="active" to="/settings/security" id="settings-user-security"><SettingsSecurity /><span>Security</span></NavLink>
					<NavLink activeClassName="active" to="/settings/notifications" id="settings-user-notifications"><SettingsNotification /><span>Notifications</span></NavLink>
					<NavLink activeClassName="active" to="/settings/create/shop" id="settings-user-shop"><SettingsCreate /><span>Create Shop</span></NavLink>
				</div>
			</div>

			<div className="settings-mobile-nav-list">
				<div className="settings-mobile-nav-list-title">Shop</div>
				<div className="settings-mobile-nav-list-body">
					<NavLink activeClassName="active" to="/settings/shop/general" id="settings-shop-general"><SettingsShop /><span>General</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/payments" id="settings-shop-payments"><SettingsPayments /><span>Payments</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/crypto" id="settings-shop-crypto"><SettingsCrypto /><span>Cryptocurrencies</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/tax" id="settings-shop-tax"><SettingsTax /><span>Tax</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/currencies" id="settings-shop-currencies"><SettingsCurrencies /><span>Currencies</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/shopify" id="settings-shop-shopify"><SettingsShopify isActive={isShopify} /><span>Shopify</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/cart" id="settings-shop-cart"><SettingsCart /><span className="d-flex align-items-center justify-content-start">Shopping Cart</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/subscription" id="settings-shop-subscription"><SettingsSubs /><span className="d-flex align-items-center justify-content-start">Subscriptions</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/design" id="settings-shop-design"><SettingsDesign /><span>Design</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/managers" id="settings-shop-managers"><SettingsManagers /><span>Managers</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/fraud" id="settings-shop-fraud"><SettingsFraud /><span>Fraud</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/affiliate" id="settings-shop-affiliate"><CustomersAffiliate /><span>Affiliate</span></NavLink>
					<NavLink activeClassName="active" to="/settings/shop/gateway-fees" id="settings-shop-gateway-fees"><SettingsGatewayFees /><span>Gateway Adjustments</span></NavLink>
				</div>
			</div>
		</div>

	</div>
}


export default MobileNav;
